import { takeLatest } from 'redux-saga/effects';
import { COMMON_ERROR } from '../../../shared/constants/commonConstants';
import { GLOBAL_URL } from '../../../shared/constants/dataServiceUrl';
import SendRequest from '../../../shared/services/sendRequest.service';
import actionTypes from '../../types/signUpTypes';

export function* SignUpSaga({ payload }: any): Generator {
  const { formData, encryptedCaptcha, getHospitalDetails } = payload;
  const sendRequest = SendRequest.instance;
  const { hospName, registrationNo, roc, pan, pinCode, rohini_Code, city,
    service, address, speciality, spocName, mobileNo, atMobileNo, emailId,
    nabh, nabl, jci, iso, designation, department, isAuthorized, userCaptcha,
  } = formData;
  const requestJSON = {
    hospName, registrationNo, roc, pan, pinCode, rohini_Code, city, service,
    address, speciality, contactDetails: { spocName, mobileNo, atMobileNo, emailId, designation, department },
    certificationDetails: { nabh, nabl, jci, iso },
    isAuthorized, userCaptcha, encryptedCaptcha,
  };
  const url = `${GLOBAL_URL.CRM_BASE_URL}Provider/Register`;
  try {
    const response: any = yield sendRequest.post<any, any>
      (url, requestJSON, { isShowErrorInInterceptor: false });
    getHospitalDetails(response);
    return;
  } catch (e) {
    getHospitalDetails(e);
  }
}

export function* SignUpSpecialitySaga({ payload }: any): Generator {
  const { requestJSON, getSpecialityDetail } = payload;
  const sendRequest = SendRequest.instance;

  const url = `${GLOBAL_URL.CRM_BASE_URL}Master/RegistrationLookUp`;
  try {
    const response: any = yield sendRequest.post<any, any>
      (url, requestJSON, { isShowErrorInInterceptor: false });
    getSpecialityDetail(response);
    return;
  } catch (e) {
    console.error(e);
  }
}

export function* fetchCaptcha({ payload: { onSuccess = (result: any): any => { }, onError = (): any => { } } }: any): Generator {
  const sendRequest = SendRequest.instance;
  try {
    const url = `${GLOBAL_URL.CRM_BASE_URL}Provider/CaptchaImage`;
    const response: any = yield sendRequest.post(url, {}, { isShowErrorInInterceptor: false });
    const { isSuccess, errors } = response;
    if (isSuccess) {
      onSuccess(response);
    } else {
      onError(errors.join('\n'));
    }
  } catch (e) {
    onError(COMMON_ERROR);
  }
}

export function* watchSignUpAction(): any {
  yield takeLatest(actionTypes.SIGN_UP, SignUpSaga);
  yield takeLatest(actionTypes.SIGN_UP_SPECIALITY, SignUpSpecialitySaga);
  yield takeLatest(actionTypes.FETCH_CAPTCHA, fetchCaptcha);
}

export default watchSignUpAction;
